import { type UTheme } from '@/theme';

interface ISTSBParams {
  host: string;
  cid: string;
  isShadowMode: boolean;
  hostname: string;
  isSDK: boolean;
  scrollParent: {
    element: HTMLElement | Document;
    selector: string;
  };
  mainFrameUrl?: string;
  disallowUrlChange?: boolean;
  lang?: string;
  theme?: UTheme;
  token?: string;
  containerId?: string;
  customStyles?: string;
  sub_partner_id?: string;
  loginUrl?: string;
  themeEditorData?: string | Record<string, unknown>;
  depositUrl?: string;
  lineFilter?: 'sport' | 'esport' | string;
  sportsbookSearchOpen?: string | boolean;
  sportsbookMyBetsOpen?: string | boolean;
  sportsbookBetslipOpen?: string | boolean;
  registerUrl?: string;
  locale?: string;
  oddsFormat?: string;
  isDemoApp?: string;
  hasParentIframe?: string;
  viewType?: string;
  isHideLanguagePicker?: string | boolean;
  bannerBetslip?: string;
  hideScrollToTopButton?: string | boolean;
  tokenUsdRate?: number;
  originFrame?: string;
  delistedToken?: {
    tokenName: string;
    logo: string;
  } | null;
}

declare global {
  interface Window {
    STSB_params?: ISTSBParams;
  }
}

const initialShadowModeParams: ISTSBParams = window.STSB_params || {
  cid: '',
  hideScrollToTopButton: false,
  host: '',
  hostname: '',
  isSDK: false,
  isShadowMode: false,
  scrollParent: {
    element: document,
    selector: '',
  },
};

// Export in 'let' variable to allow dynamic updates
export let shadowModeParams: ISTSBParams = initialShadowModeParams;
export let isShadowMode: boolean;
export let host!: string;
export let hostname!: string;
export let socketHost!: string;
export let core!: string;
export let iconHost!: string;
export let dexurl!: string;

/**
 * Recalculates derived values (host, hostname, socketHost, core, iconHost)
 * and updates isShadowMode based on the current shadowModeParams.
 */
function syncDerivedParams(): void {
  isShadowMode = shadowModeParams.isShadowMode;
  host = shadowModeParams.host || window.location.origin;
  hostname = shadowModeParams.hostname || window.location.hostname;
  socketHost = process.env.SOCKET_HOST || `wss://${hostname}/ws`;
  core = process.env.CORE || `https://${hostname}`;
  iconHost = process.env.CORE ? `${process.env.CORE}/icons` : `https://${hostname}/icons`;

  dexurl = process.env.DEX_API || `https://mainnet.dexsport.io/api`;
}

// Initial calculation
syncDerivedParams();

// Override window.STSB_params to intercept assignments and keep local state in sync
Object.defineProperty(window, 'STSB_params', {
  configurable: true,
  get(): ISTSBParams {
    return { ...initialShadowModeParams, ...shadowModeParams };
  },
  set(value: ISTSBParams) {
    // Update local copy of params and re-sync all derived exports
    shadowModeParams = { ...initialShadowModeParams, ...value };
    syncDerivedParams();
  },
});
